/* global axios */
import ApiClient from './ApiClient';

class TalkviaInventoryProductGroupsAPI extends ApiClient {
  constructor() {
    super('talkvia_inventory_product_groups', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_inventory_product_group: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      talkvia_inventory_product_group: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TalkviaInventoryProductGroupsAPI();
